/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { RichText, Flex, FlexItem, toast } from '@chatui/core';// 引入样式
import { Form } from "antd";
import HeadeNavbar from '../components/headeNavbar'
import AntdFormToValues from '../components/template/antdFormToValues'
import TicketFeedback from '../components/template/ticketFeedback'
import { getOneTicket, ticketInfoList, ticketInfoRead } from '../services/ticket';
import { isEntity } from '../utils/entity';

const MyWorkOrderInfo = props => {
  const [template, setTemplate] = useState({});
  const [chatList, setChatList] = useState([]);

  const getTicketInfoList = () => {
    ticketInfoList({ ticketId: props.location.query.ticketId })
      .then(res2 => {
        if (res2.code === 0 && res2.data.code === 0) {
          setChatList(res2.data.data)
        } else {
          toast.show(res2.data.message || res2.msg)
        }
      })
  }

  const getTicket = () => {
    getOneTicket({ ticketId: props.location.query.ticketId })
      .then(res => {
        if (res.code === 0 && res.data.code === 0) {
          setTemplate(res.data.data)
          getTicketInfoList()
          ticketInfoRead({ ticketId: props.location.query.ticketId })
        }
      })
  }
  useEffect(() => {
    if (!props.location?.query?.ticketId) {
      props.history.push({ pathname: '/workOrderList', search: props.location.search })
    } else {
      getTicket()
    }
  }, []);

  const escapeHtml = (value) => {
    if (typeof value !== 'string') {
      return value
    }
    return value.replace(/[&<>`"'\/]/g, function (result) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '`': '&#x60;',
        '"': '&quot;',
        "'": '&#x27;',
        '/': '&#x2f;',
      }[result]
    })
  };

  return (
    <HeadeNavbar title={"反馈详情"}>
      <Flex direction='column' style={{ padding: '1em 2em' }}>
        <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', borderStyle: 'none none none solid', borderColor: "var(--brand-1)", borderWidth: '4px' }}>工单详情</FlexItem>
        <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', }}>
          <Form
            layout='vertical'
          >
            {(template.fields || []).map((item, index) => {
              return AntdFormToValues(item, index)
            })}
          </Form>
        </FlexItem>
        <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', borderStyle: 'none none none solid', borderColor: "var(--brand-1)", borderWidth: '4px' }}>处理记录</FlexItem>
        <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', }}>
          {(chatList || []).map((item, index) => {
            let type = '',
              displayName = '',
              file_url = '';
            switch (item.reply_role) {
              case '1':
                type = '客服'
                displayName = isEntity("youzu") ? '游族客服' : '游戏客服'
                break;
              case '2':
                type = '用户'
                displayName = escapeHtml(item.account)
                break;
              case '3':
                type = '系统'
                displayName = '系统消息'
                break;
              default:
                break;
            }
            if (item.file_url) {
              file_url = '<img class="ticket-img-preview" src="' + escapeHtml(item.file_url) + '">'
            }

            return <div key={index}>
              <p>
                <span style={{ color: "var(--brand-1)", fontSize: '18px', paddingRight: '5px' }}>{type}</span>
                <span style={{ fontSize: '18px', paddingRight: '10px' }}>{displayName}</span>
                <span>{item.created_at}</span>
              </p>
              {item.reply_content && <RichText content={item.reply_content} />}
              {item.file_url && <RichText content={file_url} />}
            </div>
          })}
        </FlexItem>
        {TicketFeedback(template, getTicket, getTicketInfoList)}
      </Flex>
    </HeadeNavbar>
  );
};

export default MyWorkOrderInfo;
